import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const PlayerLanguageModalIconContainer = styled.div<React.CSSProperties>`
  left: ${72 * Screen.widthRatio}px;
  top: ${72 * Screen.widthRatio}px;
  position: absolute;
`;

export default PlayerLanguageModalIconContainer;
